export default __webpack_public_path__ + "static/media/2.2da95e6e.jpg";